import detectExplorerEdge from './detectExplorerEdge'

const isExplorerOrEdge = detectExplorerEdge()

function internetExplorerFixes(rootElement) {
  // "Internet Explorer is the only mainstream browser to implement
  // SVG 1.2 Tiny's focusable attribute to make arbitrary elements
  // focusable. However, it does not support the tabindex attribute
  // and .focus() method on SVGElements."
  // "Support for focusable and the lack of .focus() carried over to
  // Microsoft Edge, which only added support for the tabindex
  // attribute in version 14."
  //
  // Therefore, keyboard focus is disabled for IE by forcing
  // "focusable" to be false.
  //
  // source: https://allyjs.io/tutorials/focusing-in-svg.html
  if (isExplorerOrEdge) {
    const svgs = rootElement.querySelectorAll('svg')
    svgs.forEach((svg) => {
      svg.setAttribute('focusable', 'false')
    })
  }
}

export default internetExplorerFixes
